const o = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><defs></defs><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M7.875.75h8.25s3 0 3 3v16.5s0 3-3 3h-8.25s-3 0-3-3V3.75s0-3 3-3"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.834 3.633h1.402s1 0 1 1v4.983s0 1-1 1H8.834s-1 0-1-1V4.633s0-1 1-1"></path></svg>';
export {
  o as default
};
